/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, date: NonNullable<unknown> }} Receipt_Seats_UntilInputs */



/**
* | output |
* | --- |
* | "{count} seats until {date}" |
*
* @param {Receipt_Seats_UntilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_seats_until = /** @type {((inputs: Receipt_Seats_UntilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Seats_UntilInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Plätze bis ${i?.date}`)
	return /** @type {LocalizedString} */ (`${i?.count} seats until ${i?.date}`)
});